// hooks/useAuthenticatedQuery.ts
import {
  useQuery,
  useMutation,
  QueryHookOptions,
  MutationHookOptions,
} from "@apollo/client";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";

export const useAuthenticatedQuery = (
  query: any,
  options: QueryHookOptions = {}
) => {
  // const { user, isAuthenticated } = useAuth();
  const { isAuthenticated } = useAuth();

  const result = useQuery(query, {
    ...options,
    skip: !isAuthenticated || options.skip, // Skip if not authenticated
  });

  useEffect(() => {
    if (result.error) {
      console.error("GraphQL Error:", result.error);
    }
  }, [result.error]);

  return result;
};

export const useAuthenticatedMutation = (
  mutation: any,
  options: MutationHookOptions = {}
) => {
  const { isAuthenticated } = useAuth();

  const [execute, result] = useMutation(mutation, options);

  const authenticatedExecute = (...args: any[]) => {
    if (!isAuthenticated) {
      throw new Error("Authentication required");
    }
    return execute(...args);
  };

  return [authenticatedExecute, result] as const;
};
